// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../node_modules/css-loader/index.js??ref--6-1!../node_modules/postcss-loader/lib/index.js??ref--6-2!../node_modules/sass-loader/lib/loader.js??ref--6-3!./main.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../node_modules/vue-style-loader/lib/addStylesClient.js")("15e68910", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/main.scss
// module id = DL/1
// module chunks = 0